import { QuestionnaireResponseItem } from '@medplum/fhirtypes'
import { BaseSubsectionAdapter } from 'components/Assessments/adapters/BaseSubsectionAdapter'
import { AdapterOptions, FlatAnswerMutation } from 'components/Assessments/adapters/types'
import { getAnswerValuesFromItems } from 'components/Assessments/helpers'
import { getSkilledNeedDescription } from 'components/Assessments/constants/skilledNeedsDescriptions'
import { FuaFormData } from 'components/Assessments/FuaAssessment/types/FuaFormData'
import { FuaAssessmentQuestionnaireItem } from 'components/Assessments/FuaAssessment/types/questionnaire'
import { SkilledNeed } from './formData'
import { SkilledNeedsFormField } from './formField'

/**
 * Skilled Needs subsection adapter for FUA Assessment
 * Handles skilled needs extraction and transformation
 */
export class SkilledNeedsAdapter extends BaseSubsectionAdapter<FuaFormData> {
  extractFormData(
    flatAnswers: Record<string, QuestionnaireResponseItem>,
    _options?: AdapterOptions
  ): Partial<FuaFormData> {
    const skilledNeedsAnswers =
      flatAnswers[FuaAssessmentQuestionnaireItem.SKILLED_NEEDS_NEED]?.answer ?? []
    const skilledNeedsFormData = skilledNeedsAnswers.map<SkilledNeed>((skilledNeedAnswerItem) => {
      const skilledNeedInfoItem = skilledNeedAnswerItem.item ?? []
      const name = getAnswerValuesFromItems(
        skilledNeedInfoItem,
        FuaAssessmentQuestionnaireItem.SKILLED_NEEDS_NEED_NAME
      )?.at(0)

      const score = getAnswerValuesFromItems(
        skilledNeedInfoItem,
        FuaAssessmentQuestionnaireItem.SKILLED_NEEDS_NEED_SCORE
      )?.at(0)

      const note = getAnswerValuesFromItems(
        skilledNeedInfoItem,
        FuaAssessmentQuestionnaireItem.SKILLED_NEEDS_NEED_NOTE
      )?.at(0)

      const previousNote = getAnswerValuesFromItems(
        skilledNeedInfoItem,
        FuaAssessmentQuestionnaireItem.SKILLED_NEEDS_NEED_PREVIOUS_NOTE
      )?.at(0)

      // Description is derived from name and score, not stored directly
      const dynamicDescription = getSkilledNeedDescription(name, score)
      const description = dynamicDescription ? `${score} - ${dynamicDescription}` : 'unknown'

      return {
        [SkilledNeedsFormField.SKILLED_NEED_NAME]: name,
        [SkilledNeedsFormField.SKILLED_NEED_SCORE]: score,
        [SkilledNeedsFormField.SKILLED_NEED_NOTE]: note,
        [SkilledNeedsFormField.SKILLED_NEED_PREVIOUS_NOTE]: previousNote,
        [SkilledNeedsFormField.SKILLED_NEED_DESCRIPTION]: description
      }
    })
    return {
      [SkilledNeedsFormField.SKILLED_NEED]: skilledNeedsFormData
    }
  }

  buildFlatAnswers(): FlatAnswerMutation[] {
    return []
  }
}
